export const MACHINE_POSITION_HISTORY_MAP_CONSTANTS = {
  mapInstanceId: 'machine-position-history-map',
};
